import React from "react";
import { useFormContext } from "react-hook-form";

import Label from "./Label";
import { isInvalidClass, validationClass, validationMode } from "../../config/helpers";

interface IProps {
  label?: string;
  type?: string;
  formName: string;
  placeholder?: string;
  ismandatory?: boolean;
  popover?: string;
  validationStyle?: validationMode;
  disabled?: boolean;
  value?: string;
  onchange?: (value: string) => void;
  maxLength?: number;
}

const TextInput: React.FC<IProps> = ({
  formName,
  type,
  label = formName,
  ismandatory,
  placeholder,
  popover,
  validationStyle = validationMode.classic,
  disabled,
  value,
  onchange,
  maxLength,
}) => {
  //variables disponibles parce que le composant est intégré dans un <FormProvider>

  const {
    getValues,
    getFieldState,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    formState: { errors },
    //trigger,
    setValue,
    register,
  } = useFormContext();

//   const validationClassName = (): string => {
//     switch (validationStyle) {
//       case validationMode.classic:
//         return validationClass(
//           getFieldState(formName).error,
//           !getFieldState(formName).error && getValues(formName)
//         );
//       case validationMode.invalid:
//         return isInvalidClass(getFieldState(formName).error);
//       default:
//         break;
//     }
//   };

  const validationClassName = (): string => {
    const fieldState = getFieldState(formName);
    const values = getValues(formName);
    const error = fieldState?.error;

    switch (validationStyle) {
      case validationMode.classic:
        return validationClass(error, !error && values);
      case validationMode.invalid:
        return isInvalidClass(error);
      default:
        return ""; // Retourne une chaîne vide par défaut
    }
};


const handleChange = (name: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
  let newValue = event.target.value;
  
  // Si le type est "number", ne garder que les chiffres (pas de négatif)
  if (type === "number") {
    newValue = newValue.replace(/[^0-9]/g, '');
  }
  
  // Si le champ est CodePostal, ne garder que les lettres (sans accents), chiffres et espaces
  if (name === "CodePostal") {
    newValue = newValue.replace(/[^a-zA-Z0-9\s]/g, '');
  }
  
  setValue(name, newValue);
  onchange && onchange(newValue);
};

const handleKeyDown = (name: string) => (event: React.KeyboardEvent<HTMLInputElement>) => {
  // Bloquer le signe moins (-) et le point (.) pour les champs numériques
  if (type === "number" && (event.key === '-' || event.key === '.' || event.key === ',' || event.key === 'e' || event.key === 'E' || event.key === '+')) {
    event.preventDefault();
  }
  
  if (event.key === 'Enter') {
    //setValue(name,event.currentTarget.value);
    event.preventDefault();
  }
};

const handleInput = (event: React.FormEvent<HTMLInputElement>) => {
  const input = event.currentTarget;
  
  // Pour les champs numériques, supprimer tous les caractères non numériques
  if (type === "number") {
    input.value = input.value.replace(/[^0-9]/g, '');
  }
  
  // Pour les champs CodePostal, ne garder que les lettres (sans accents), chiffres et espaces
  if (formName === "CodePostal") {
    input.value = input.value.replace(/[^a-zA-Z0-9\s]/g, '');
  }
};



  return (
    <Label
      label={label}
      htmlFor={formName}
      errors={getFieldState(formName)?.error?.message?.toString()}
      ismandatory={ismandatory}
      popover={popover}
    >
      <input
        type={type === "number" ? "text" : (type || "text")}
        id={formName}
        {...register(formName)}
        className={`form-control ${validationClassName()}`}
        placeholder={placeholder}
        disabled={disabled}
        value={value}
        onChange={handleChange(formName)}
        onKeyDown={handleKeyDown(formName)}
        onInput={handleInput}
        maxLength={maxLength}
        inputMode={type === "number" ? "numeric" : undefined}
        pattern={type === "number" ? "[0-9]*" : undefined}
      />
    </Label>
  );
};

export default TextInput;
